
  import { Component, Vue } from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
  import RadioButton from '@/components/radio-button.vue';
  import PickerDate from '@/components/picker-date.vue';
	import{
		getSearchDate,
    nextDay
	}from "@/utils/index"
  import {
    orderSupportorderSupportProductStatistic
  } from "@/api/order"
	import {
		providerSelectItem,
	} from '@/api/supplier';
  @Component({  
    name: '',
    components: {
      RadioButton,
      PageFooter,
      PickerDate
    }
  })

  export default class ProductList extends Vue {
    private radioType = 0
    private radioList = [
      {
        label: '已完成售后的商品',
        value: 0
      }, {
        label: '售后中的商品',
        value: 1
      }
    ]
    private supplierlever = null
    private supplierList = []
    private keywords = ''
    private filterTime = ''
    private filterTime1 = ''
    private tablelist:any = []
    private tableloading = false
    private pageNo = 1;
    private pageSize = 10;
    private statisticalmsg:any = {}

    private supplierTypes = [
      {value:null,label:'全部'},
      {value:1,label:'服务合同'},
      {value:2,label:'购销合同'},
    ];
    private supplierType = null;

    private mounted () {
      this.filterTime = getSearchDate(1).join('/')
      this.getSupplierList()
    }
    activated (){
      this.getList()
    }

    private exportlist(){
      let url = location.origin + '/pc/orderSupport/orderSupportProductStatisticExport'
      url += '?ProviderId=' + (this.supplierlever||'')
      url += '&ProductName=' + (this.keywords||'')
      url += '&ProviderContractType=' + (this.supplierType || '')
      if (this.filterTime){
        var splitList = this.filterTime.split('/');
        url += '&StartTime=' + splitList[0]
        url += '&EndTime=' + nextDay(splitList[1],1)
      }
      if (this.filterTime1){
        var splitList1 = this.filterTime1.split('/');
        url += '&CompleteStartTime=' + splitList1[0]
        url += '&CompleteEndTime=' + nextDay(splitList1[1],1)
      }
      url += '&SupportState=' + this.radioType
      window.open(url)
    }

    private lookdetail(row){
      this.$router.push({
        name:'shopStatistical_detail',
        query:{
          Id:row.ProductId||0,
          type:this.radioType+'',
          name:encodeURIComponent(row.ProductName||''),
          filterTime:this.filterTime,
          filterTime1:this.filterTime1
        }
      })
    }
    private changePage(e){
      this.pageNo = e
      this.getList()
    }
    private clearSearch(){
      this.supplierlever = null
      this.keywords = ''
      this.pageNo = 1;
      this.filterTime1 = '';
      this.filterTime = getSearchDate(1).join('/')
      this.supplierType = null;
      // if(this.radioType==0){
      //   this.filterTime = [getSearchDate(2,false,-29)[0],getSearchDate(2)[0]].join('/')
      // }else{
      //   this.filterTime = ''
      // }
      this.getList()
    }
    private changeradioType(){
      this.pageNo = 1;
      this.filterTime1 = '';
      this.filterTime = getSearchDate(1).join('/')
      // if(this.radioType==0){
      //   this.filterTime = [getSearchDate(2,false,-29)[0],getSearchDate(2)[0]].join('/')
      // }else{
      //   this.filterTime = ''
      // }
      this.getList()
    }
    private doSearch(){
      this.pageNo = 1
      this.getList()
    }
    private async getList(){
      try{
        this.tableloading = true
        let data:any = {
          SupportState:this.radioType,
          ProviderId:this.supplierlever,
          ProductName:this.keywords,
          Skip:(this.pageNo-1)*this.pageSize,
          Take:this.pageSize,
          ProviderContractType: this.supplierType
        }
        
				if (this.filterTime && this.radioType !=3){
					var splitList = this.filterTime.split('/');
					data.StartTime = splitList[0];
					data.EndTime = splitList[1] ? (nextDay(splitList[1],1)) : '';
				}
        if (this.filterTime1){
					var splitList1 = this.filterTime1.split('/');
					data.CompleteStartTime = splitList1[0];
					data.CompleteEndTime = splitList1[1] ? (nextDay(splitList1[1],1)) : '';
				}
        let res = await orderSupportorderSupportProductStatistic(data)
        if(res.IsSuccess){
          this.tablelist = res.Result.Results
          this.statisticalmsg = res.Result
        }
      }finally{
        this.tableloading = false
      }
    }
    
		// 获取供应商列表
		private async getSupplierList() {
			try {
				const res: any = await providerSelectItem({});
				this.supplierList = res.Result
			} catch (e) {
        //
			}
		}
  }
